import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5dc248c4")

_pushScopeId("data-v-5dc248c4")
const _hoisted_1 = { class: "bg-white mb-1" }
const _hoisted_2 = { class: "container d-flex flex-nowrap p-3 align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "me-1 me-lg-5",
  width: "200",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "ms-2 ms-lg-5 flex-nowrap d-none d-lg-flex" }
const _hoisted_5 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Menu, {
      class: "d-absolute d-lg-none",
      ref: "menu",
      model: [..._ctx.menuItems, ..._ctx.userMenuItems],
      popup: true
    }, null, 8, ["model"]),
    _createVNode(_component_Menu, {
      class: "d-none d-lg-block",
      ref: "menuUser",
      model: _ctx.userMenuItems,
      popup: true
    }, null, 8, ["model"]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _ctx.user?.userHomePage ?? '/'
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Menu, {
          ref: "settingsMenu",
          model: _ctx.settingsSubItems,
          popup: true
        }, null, 8, ["model"]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menuItems, (menuItem) => {
          return (_openBlock(), _createBlock(_Fragment, {
            key: menuItem.label
          }, [
            (menuItem.items)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: ["ms-4 btn d-flex align-items-center", { 'router-link-active': _ctx.isSettingsActive }],
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSettingsMenu($event)))
                }, [
                  _createTextVNode(_toDisplayString(menuItem.label) + " ", 1),
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'chevron-down'],
                    class: "ms-2",
                    size: "sm"
                  })
                ], 2))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "ms-4 btn",
                  to: menuItem.to!
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(menuItem.label), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
          ], 64))
        }), 128))
      ]),
      _createVNode(_component_Button, {
        onClick: _ctx.toggle,
        style: {"height":"50px","width":"50px"},
        class: "\n          ms-auto\n          d-flex d-lg-none\n          primary\n          inverted\n          rounded-circle\n          p-2\n          align-items-center\n          justify-content-center\n        "
      }, {
        default: _withId(() => [
          _createVNode(_component_font_awesome_icon, {
            size: "lg",
            icon: ['fas', 'bars']
          })
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        onClick: _ctx.toggle,
        class: "\n          primary\n          inverted\n          d-none d-lg-flex\n          ms-auto\n          d-flex\n          align-items-center\n        "
      }, {
        default: _withId(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'user'],
            class: "\n            me-2\n            d-flex\n            align-items-center\n            justify-content-center\n            rounded-circle\n          ",
            width: "54",
            height: "54"
          }),
          (_ctx.user)
            ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.user.name), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})